/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type CategoryTiles_viewer$ref = any;
export type CategoryTiles_viewer = {
    readonly trendingFurniture?: ReadonlyArray<{
        readonly displayName: string | null;
        readonly url: string | null;
        readonly image: string | null;
    } | null> | null;
    readonly trendingArt?: ReadonlyArray<{
        readonly displayName: string | null;
        readonly url: string | null;
        readonly image: string | null;
    } | null> | null;
    readonly trendingFashion?: ReadonlyArray<{
        readonly displayName: string | null;
        readonly url: string | null;
        readonly image: string | null;
    } | null> | null;
    readonly trendingJewelry?: ReadonlyArray<{
        readonly displayName: string | null;
        readonly url: string | null;
        readonly image: string | null;
    } | null> | null;
    readonly " $refType": CategoryTiles_viewer$ref;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Literal",
  "name": "categoryLevels",
  "value": 2
},
v1 = {
  "kind": "Literal",
  "name": "numItems",
  "value": 2
},
v2 = {
  "kind": "Literal",
  "name": "trendType",
  "value": "CATEGORY"
},
v3 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "displayName",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "url",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "image",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Fragment",
  "name": "CategoryTiles_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "showModules",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "showModules",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "trendingFurniture",
          "name": "trending",
          "storageKey": "trending(categoryLevels:2,numItems:2,parentCategory:\"FURNITURE\",trendType:\"CATEGORY\")",
          "args": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "kind": "Literal",
              "name": "parentCategory",
              "value": "FURNITURE"
            },
            (v2/*: any*/)
          ],
          "concreteType": "TrendingModules",
          "plural": true,
          "selections": (v3/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": "trendingArt",
          "name": "trending",
          "storageKey": "trending(categoryLevels:2,numItems:2,parentCategory:\"ART\",trendType:\"CATEGORY\")",
          "args": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "kind": "Literal",
              "name": "parentCategory",
              "value": "ART"
            },
            (v2/*: any*/)
          ],
          "concreteType": "TrendingModules",
          "plural": true,
          "selections": (v3/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": "trendingFashion",
          "name": "trending",
          "storageKey": "trending(categoryLevels:2,numItems:2,parentCategory:\"FASHION\",trendType:\"CATEGORY\")",
          "args": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "kind": "Literal",
              "name": "parentCategory",
              "value": "FASHION"
            },
            (v2/*: any*/)
          ],
          "concreteType": "TrendingModules",
          "plural": true,
          "selections": (v3/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": "trendingJewelry",
          "name": "trending",
          "storageKey": "trending(categoryLevels:2,numItems:2,parentCategory:\"JEWELRY\",trendType:\"CATEGORY\")",
          "args": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "kind": "Literal",
              "name": "parentCategory",
              "value": "JEWELRY"
            },
            (v2/*: any*/)
          ],
          "concreteType": "TrendingModules",
          "plural": true,
          "selections": (v3/*: any*/)
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'bb4bdf453d0981f8991cd62540fee26a';
export default node;
